/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    /**************************************/
    // Accessibility Need Data View Model
    // Holds the accessibility needs data
    /**************************************/
    function AccessibilityNeedViewModel() {

        // Self-Identification
        var self = this;
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();
		var resetAccessibilityDropDown = 0;
        /***  PROPERTIES ***/
        this.DataList = ko.observableArray();
        this.ID = ko.observable();
        this.GID = ko.observable();
        this.sectionIncluded = ko.observable(false);
        /***  PROPERTIES ***/

        /***  LIST DATA PROPERTIES ***/
        this.AccessibilityNeedTypes = ko.observableArray();
        this.DisabilityStatuses = ko.observableArray();
        this.DisabilityStatusMatrix = ko.observableArray();
        this.DisabledStudentAllowances = ko.observableArray();
        /***  LIST DATA PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.DataLoaded = ko.observable(false);
        this.DataLoading = ko.observable(false);
        this.DataContainer = ko.observable("AccessibilityNeedContainer");
        this.Touched = ko.observable(false);
        this.IsRequired = ko.observable(false);
        this.DataLoadErrorCount = ko.observable(0);
        this.sectionVisibleByConfig = ko.observable(null);
        this.AccessibilityNeedBooleanValue = ko.validatedObservable();
        this.AccessibilityNeedInfoText = ko.observable('');
        this.HideAddAccessibility = ko.observable(false);
        this.NoAccessibilityNeedInformationEntered = ko.observable('NoAccessibilityNeedInformationEntered');
        sm.portal.vm.custom.setCustomLocalizeKey(self);
        sm.portal.vm.custom.callCustomization('SubscribeAccessibilityNeed', self);
        /*** SECTION PROPERTIES ***/

        /** ADD/EDIT LIST METHODS **/
        this.WorkingItem = ko.observable(new sm.portal.vm.AccessibilityNeedDataItem({
            AccessibilityNeedTypes: this.AccessibilityNeedTypes,
            DisabilityStatuses: this.DisabilityStatuses,
            DisabledStudentAllowances: this.DisabledStudentAllowances,
            DisabilityStatusMatrix: this.DisabilityStatusMatrix
        }));
        this.OriginalItem = ko.observable(new sm.portal.vm.AccessibilityNeedDataItem({
            AccessibilityNeedTypes: this.AccessibilityNeedTypes,
            DisabilityStatuses: this.DisabilityStatuses,
            DisabledStudentAllowances: this.DisabledStudentAllowances,
            DisabilityStatusMatrix: this.DisabilityStatusMatrix
        }));

        self.isDataItemValid = ko.computed(function () {
            return self.WorkingItem().IsVMValid();
        }, self);

        this.EnableAccessibilitySaveButon = function () {
            return self.WorkingItem().IsVMValid();
        }

        sm.portal.vm.custom.callCustomization('updatePropertiesForAccessibility', self);

        this.SaveWorkingChanges = function () {

            var workingItem = new sm.portal.vm.AccessibilityNeedDataItem({
                AccessibilityNeedTypeID: self.WorkingItem().AccessibilityNeedTypeID(),
                AccessibilityNeedType: self.WorkingItem().AccessibilityNeedType(),
                DisabilityStatusID: self.WorkingItem().DisabilityStatusID(),
                DisabilityStatus: self.WorkingItem().DisabilityStatus(),
                DisabledStudentAllowanceID: self.WorkingItem().DisabledStudentAllowanceID(),
                DisabledStudentAllowanceName: self.WorkingItem().DisabledStudentAllowanceName(),
                Description: self.WorkingItem().Description(),
                InEditMode: self.WorkingItem().InEditMode(),
                AccessibilityNeedTypes: this.AccessibilityNeedTypes,
                DisabilityStatuses: this.DisabilityStatuses,
                DisabledStudentAllowances: this.DisabledStudentAllowances,
                DisabilityStatusMatrix: this.DisabilityStatusMatrix,
                SectionRequired: self.IsRequired(),
                ID: self.WorkingItem().ID(),
                GID: self.WorkingItem().GID()
            });

            if (workingItem.AccessibilityNeedTypeID()) {
                workingItem.AccessibilityNeedType(self.GetAccessibilityNeedTypeNameById(workingItem.AccessibilityNeedTypeID()).name);
            }

            if (workingItem.DisabilityStatusID()) {
                workingItem.DisabilityStatus(self.GetDisabilityStatusNameById(workingItem.DisabilityStatusID()).name);
            }

            if (workingItem.DisabledStudentAllowanceID()) {
                workingItem.DisabledStudentAllowanceName(self.GetDisabledStudentAllowanceNameById(workingItem.DisabledStudentAllowanceID()).name);
            }

            self.WorkingItem(new sm.portal.vm.AccessibilityNeedDataItem({
                AccessibilityNeedTypes: this.AccessibilityNeedTypes,
                DisabilityStatuses: this.DisabilityStatuses,
                DisabledStudentAllowances: this.DisabledStudentAllowances,
                DisabilityStatusMatrix: this.DisabilityStatusMatrix
            }));

            var customData = {
                workingItem : workingItem,
                self : self
            }
            sm.portal.vm.custom.callCustomization('SaveWorkingChangesForAccessibilityNeed', customData);

            if (workingItem.IsVMValid()) {

                if (!workingItem.InEditMode()) {
                    // This is an Add...
                    self.DataList.push(workingItem);
                } else {
                    // NOTE: Edits automatically bind back to the list (knockout is cool, huh?)
                    workingItem.InEditMode(false);
                    self.OriginalItem().AccessibilityNeedTypeID(workingItem.AccessibilityNeedTypeID());
                    self.OriginalItem().AccessibilityNeedType(workingItem.AccessibilityNeedType());
                    self.OriginalItem().DisabilityStatusID(workingItem.DisabilityStatusID());
                    self.OriginalItem().DisabilityStatus(workingItem.DisabilityStatus());
                    self.OriginalItem().DisabledStudentAllowanceID(workingItem.DisabledStudentAllowanceID());
                    self.OriginalItem().DisabledStudentAllowanceName(workingItem.DisabledStudentAllowanceName());
                    self.OriginalItem().Description(workingItem.Description());
                    self.OriginalItem().InEditMode(workingItem.InEditMode());
                    self.OriginalItem().DisabilityStatusMatrix(workingItem.DisabilityStatusMatrix());
                    self.OriginalItem().ID(workingItem.ID);
                    self.OriginalItem().GID(workingItem.GID);

                }
                
                sm.portal.vm.custom.callCustomization('UpdateAccessibilityWorkingItem', customData);

                sm.portal.ui.comboBox();

                // hide the data entry view
                jQuery('.dataEntryView').hide();

                // show the display view with one item
                jQuery('.dataDisplayView').show();
                jQuery('.dataDisplayView ul.detailedList li').not('.noneAdded').show();
            }
        };

        this.GetAccessibilityNeedTypeNameById = function (id) {

            for (var i = 0; i < self.AccessibilityNeedTypes().length; i++) {
                if (self.AccessibilityNeedTypes()[i].Value() == id) {
                    return self.AccessibilityNeedTypes()[i].Text();
                }
            }
            return "";
        }

        this.GetDisabilityStatusNameById = function (id) {

            for (var i = 0; i < self.DisabilityStatuses().length; i++) {
                if (self.DisabilityStatuses()[i].Value() == id) {
                    return self.DisabilityStatuses()[i].Text();
                }
            }
            return "";
        }

        this.GetDisabledStudentAllowanceNameById = function (id) {

            for (var i = 0; i < self.DisabledStudentAllowances().length; i++) {
                if (self.DisabledStudentAllowances()[i].Value() == id) {
                    return self.DisabledStudentAllowances()[i].Text();
                }
            }
            return "";
        }

        this.CancelWorkingChanges = function () {
            var cancelWorkingChangesUpdated = sm.portal.vm.custom.callCustomization('CancelWorkingChangesUpdated');
            if (sm.portal.utility.isNullOrEmpty(cancelWorkingChangesUpdated)) {
                self.WorkingItem(new sm.portal.vm.AccessibilityNeedDataItem({
                    AccessibilityNeedTypes: this.AccessibilityNeedTypes,
                    DisabilityStatuses: this.DisabilityStatuses,
                    DisabledStudentAllowances: this.DisabledStudentAllowances,
                    DisabilityStatusMatrix: this.DisabilityStatusMatrix
                }));
            }


            //hide the display view
            jQuery('.dataEntryView').hide();

            // show the entry view
            jQuery('.dataDisplayView').show();
        };
        this.EditItem = function (data, event) {
            self.OriginalItem(data);

            self.WorkingItem(
                new sm.portal.vm.AccessibilityNeedDataItem(
                    JSON.parse(ko.toJSON(data))
                )
            );
            var customData = {
                data : data,
                self : self
            }
            sm.portal.vm.custom.callCustomization('EditItemForAccessibility', customData);
            self.WorkingItem().InEditMode(true);

            jQuery('.dataDisplayView').hide();
            jQuery('.dataEntryView').show();
        };
        this.AddItem = function (data, event) {
            self.WorkingItem(
                new sm.portal.vm.AccessibilityNeedDataItem(
                    JSON.parse(ko.toJSON(data))
                )
            );
        };
        this.RemoveItem = function (data, event) {
            self.DataList.remove(function (item) {
                returnData =  item.AccessibilityNeedTypeID == data.AccessibilityNeedTypeID &&
                item.DisabilityStatusID == data.DisabilityStatusID &&
                item.DisabledStudentAllowanceID == data.DisabledStudentAllowanceID &&
                item.Description == data.Description;
                
                return returnData;
            });
			if(document.getElementsByClassName('listItem withActions').length == 0){
				var dropDown=document.getElementById('AccessibilityNeedBoolean');
				dropDown.selectedIndex = resetAccessibilityDropDown;
				dropDown.dispatchEvent(new Event('change'));
			};
        };
        /** ADD/EDIT LIST METHODS **/

        /***  COMPUTED PROPERTIES ***/
        this.AnythingPopulated = ko.computed(function () {
            var res = sm.portal.vm.custom.callCustomization('PopulateAccessibilityNeedData', self);
            
            if (res == undefined && self.DataList().length > 0) {
                for (var i = 0; i < self.DataList().length; i++) {
                    var dataItem = self.DataList()[i];
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.AccessibilityNeedTypeID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.AccessibilityNeedType())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.DisabilityStatusID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.DisabilityStatus())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.DisabledStudentAllowanceID())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.DisabledStudentAllowanceName())) return true;
                    if (!sm.portal.utility.isNullOrEmpty(dataItem.Description())) return true;
                }
            }
            if (res != undefined) {
                return res;
            }
            return false;
        }, this);

        var validation = sm.portal.vm.custom.callCustomization('OverrideAccessibilityValidation', self);

        if (sm.portal.utility.isNullOrEmpty(validation) && sm.portal.utility.isNullOrEmpty(self.CompletedFlag)) {
        this.Completed = ko.computed(function () {
            if (this.IsRequired()) {
                return this.AnythingPopulated() && this.Touched();
            } else {
                return this.Touched();
            }
        }, this);            
        }

        /***  COMPUTED PROPERTIES ***/

        /*** SECTION METHODS ***/
        function loadDisabilityStatusListItemModel(source, target) {
            for (var i = 0; i < source.length; i++) {
                target.push(new DisabilityStatusListItemViewModel({
                    PrimaryID: source[i].PrimaryID,
                    PrimaryText: source[i].PrimaryText,
                    AccessibilityNeedTypeIDs: source[i].AccessibilityNeedTypeIDs
                }));
            }
            return target;
        };

        this.LoadModel = function (container) {
            // update application section configurations
            if(container && container.Payload && container.Payload.Config){
                viewModel.SetSectionsConfigData("AccessibilityNeed", container.Payload.Config);
                // To handle inclusion usecase
                var showSection = container.Payload.Config.ShowSection;
                !sm.portal.utility.isNullOrEmpty(showSection) && this.sectionVisibleByConfig(showSection);
            }
            if(container.Payload.ListData){
                this.AccessibilityNeedTypes = smapi.access.loadListItemModels(container.Payload.ListData.AccessibilityNeedTypes, this.AccessibilityNeedTypes);
                this.DisabilityStatuses = smapi.access.loadListItemModels(container.Payload.ListData.DisabilityStatuses, this.DisabilityStatuses);
                this.DisabledStudentAllowances = smapi.access.loadListItemModels(container.Payload.ListData.DisabledStudentAllowances, this.DisabledStudentAllowances);
                this.DisabilityStatusMatrix = loadDisabilityStatusListItemModel(container.Payload.ListData.DisabilityStatusChangeMatrix.DisabilityStatusLookup, this.DisabilityStatusMatrix);
                var data = {
                    self : self,
                    container : container
                }
                sm.portal.vm.custom.callCustomization('LoadAccessibilityNeedData', data);
            }
            var disabledStudentAllowanceID = 0;
            if (container.Payload.DisabledStudentAllowanceID != null) {
                disabledStudentAllowanceID = container.Payload.DisabledStudentAllowanceID;
            }

            if (container.Payload.AccessibilityNeed != null) {
                var data = {
                    self : self,
                    container : container
                }
                sm.portal.vm.custom.callCustomization('LoadModelExtraData', data); 

                var cuData = {
                    container: container
                };
                sm.portal.vm.custom.callCustomization('IsNoKnowDisabilityForAccessibility', cuData);
                
                for (var i = 0; i < container.Payload.AccessibilityNeed.length; i++) {

                    var accessibility = container.Payload.AccessibilityNeed[i];
                    var newDataItem = new sm.portal.vm.AccessibilityNeedDataItem({
                        AccessibilityNeedTypeID: accessibility.AccessibilityNeedTypeID,
                        AccessibilityNeedType: accessibility.AccessibilityNeedType,
                        DisabilityStatusID: accessibility.DisabilityStatusID,
                        DisabilityStatus: accessibility.DisabilityStatus,
                        DisabledStudentAllowanceID: disabledStudentAllowanceID,
                        DisabledStudentAllowanceName: '',
                        Description: accessibility.Description,
                        AccessibilityNeedTypes: this.AccessibilityNeedTypes,
                        DisabilityStatuses: this.DisabilityStatuses,
                        DisabledStudentAllowances: this.DisabledStudentAllowances,
                        DisabilityStatusMatrix: this.DisabilityStatusMatrix,
                        ID: accessibility.ID,
                        GID: accessibility.GID
                    });
                    
                    
                    this.DataList.push(newDataItem);
                    var data = {
                        self : self,
                        container : container,
                        accessibility : accessibility,
                        newDataItem : newDataItem
                    }
                    sm.portal.vm.custom.callCustomization('LoadAcessibilityModelData', data)
                }

            }

            this.DataLoading(false);
            this.DataLoaded(true);
            if (smapi.constant.applicationDebugFlag) { console.log('[AccessibilityNeedVM] Data Loaded'); }
        };
        this.GetModelData = function (blockui, applicationMID, personMID, callback) {
            
            if (!this.DataLoaded() && !this.DataLoading()) {

                this.DataLoading(true);
                if(!sm.portal.utility.isNullOrEmpty(viewModel.allCustomData())) {
                    self.LoadModel(viewModel.allCustomData().AccessibilityNeed);
                    callback && callback(viewModel.allCustomData().AccessibilityNeed);
                    return;
                }
                if (blockui) { jQuery.blockUI(); }
                var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/getapplicationsection?sectionName=accessibilityneed&attemptmid={0}', applicationMID);

                jQuery.ajax({
                    url: url,
                    type: 'GET',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    headers: {
                        "x-api-version": '1' //,
                    },
                    processData: false,
                    crossDomain: true,

                    xhrFields: {
                        withCredentials: true
                    },
                    success: function (data, textStatus, jqXHR) {
                        sm.portal.page.application.modelDataResponseHandler(self, data, applicationMID, personMID);
                        callback && callback(data);
                    },
                    error: function (jqXHR, exception) {
                        sm.portal.page.application.modelErrorHandler(self, jqXHR);
                        sm.portal.page.application.handleErrorWithMessages(self, jqXHR, 'fetch');
                        callback && callback();
                    }
                });
            } else {
                callback && callback();
            }
        };

        this.CheckInclusion = function (applicationMID, personMID) {
            if(self.sectionIncluded()) return;
            
            var url = _baseApiUri + sm.portal.utility.formatString('api/studentportal/CheckApplicationSectionInclusion?sectionName=accessibilityneed&attemptmid={0}', applicationMID);

            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {
                    self.sectionIncluded(true);
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        var result = container.Payload.InclusionResult;
                        var sectionsToAdd = Array();
                        var sectionsToRemove = Array();

                        console.log('Inclusion Result for Accessibility Need: ' + result);
                        switch (result) {
                            case "Included":
                                sectionsToAdd.push({ section: 'AccessibilityNeed', required: false });
                                break;
                            case "Required":
                                sectionsToAdd.push({ section: 'AccessibilityNeed', required: true });
                                break;
                            case "Exclude":
                                sectionsToRemove.push('AccessibilityNeed');
                                break;
                        }
                        console.log('Calling Maintain Sections');
                        if(self.sectionVisibleByConfig() === false && (result == "Included" || result == "Required")){
                            sectionsToAdd = null; // If section is hidden by Configuration, don't add the section
                        }
                        viewModel.MaintainSections(sectionsToAdd, sectionsToRemove);
                    }
                },
                error: function (jqXHR, exception) {
                    sm.portal.page.application.modelErrorHandler(self, jqXHR);
                }
            });
        };

        this.BlockContainer = function () {
            jQuery("#" + self.DataContainer()).block({ message: sm.portal.utility.getResourceValue('Loading') });
        };
        this.UnBlockContainer = function () {
            jQuery("#" + self.DataContainer()).unblock();
            viewModel.SetFocus();
        };
        this.ProcessOnServer = function () {
            return true;
        };
        this.ExtractATO = function () {

            var atoList = Array();
            var accessibilityNeedBooleanCheck = self.AccessibilityNeedBooleanValue();              
            
            var data = {
                atoList: atoList,
                accessibilityNeedBooleanCheck : accessibilityNeedBooleanCheck,
                self : self
            }
            sm.portal.vm.custom.callCustomization('ExtractATOAccessibility', data, function(){
                for (var i = 0; i < self.DataList().length; i++) {
                    var dataListItem = self.DataList()[i];
                    var ato = dataListItem.ExtractATO();
                    atoList.push(ko.toJS(ato));
                }
            })
            return atoList;
        };
        /*** SECTION METHODS ***/

        return self;
    };

    function AccessibilityNeedDataItem(options) {
        var defaults = {
            AccessibilityNeedTypeID: '',
            DisabilityStatusID: '',
            Description: '',
            DisabledStudentAllowanceID: '',
            DisabledStudentAllowanceName: '',
            InEditMode: false,
            ID: -1,
            GID: Guid.create().toString(),
            AccessibilityNeedTypes: null,
            DisabilityStatuses: null,
            DisabledStudentAllowances: null,
            DisabilityStatusMatrix: null
        };
        
        sm.portal.vm.custom.callCustomization('ExtraAccessibilityNeedDataItem', defaults);

        var settings = jQuery.extend({}, defaults, options);
        var ukFeatureEnabled = sm.portal.utility.isUKFeatureEnabled();
        // Self-Identification
        var self = this;

        self.AccessibilityNeedTypeID = ko.validatedObservable(settings.AccessibilityNeedTypeID);
        self.AccessibilityNeedType = ko.validatedObservable(settings.AccessibilityNeedType);
        self.DisabilityStatusID = ko.validatedObservable(settings.DisabilityStatusID);
        self.DisabilityStatus = ko.validatedObservable(settings.DisabilityStatus);
        self.DisabledStudentAllowanceID = ko.validatedObservable(settings.DisabledStudentAllowanceID);
        self.DisabledStudentAllowanceName = ko.validatedObservable(settings.DisabledStudentAllowanceName);
        self.Description = ko.validatedObservable(settings.Description);
        self.GID = ko.validatedObservable(settings.GID);
        self.ID = ko.validatedObservable(settings.ID);
        self.InEditMode = ko.observable(settings.InEditMode);
        var data = {
            self : self,
            settings : settings
        }

        sm.portal.vm.custom.callCustomization('UpdateAccessibilitySettings', data);

        if (settings.AccessibilityNeedTypes == undefined || settings.AccessibilityNeedTypes == null) {
            self.AccessibilityNeedTypes = ko.observableArray();
        } else {
            self.AccessibilityNeedTypes = settings.AccessibilityNeedTypes;
        }

        if (settings.DisabilityStatuses == undefined || settings.DisabilityStatuses == null) {
            self.DisabilityStatuses = ko.observableArray();
        } else {
            self.DisabilityStatuses = settings.DisabilityStatuses;
            var dataCus = {
                settings: settings,
                self: self
            }
            sm.portal.vm.custom.callCustomization('RemoveNoDisability', dataCus);
        }

        if (settings.DisabledStudentAllowances == undefined || settings.DisabledStudentAllowances == null) {
            self.DisabledStudentAllowances = ko.observableArray();
        } else {
            self.DisabledStudentAllowances = settings.DisabledStudentAllowances;
        }

        if (settings.DisabilityStatusMatrix == undefined || settings.DisabilityStatusMatrix == null) {
            self.DisabilityStatusMatrix = ko.observableArray();
        } else {
            self.DisabilityStatusMatrix = settings.DisabilityStatusMatrix;
        }

        
        self.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            var response = sm.portal.vm.custom.callCustomization('ExtractAtoForAccessibility', self);
            if(!sm.portal.utility.isNullOrEmpty(response)){
                return response;
            }
            var AccessibilityNeedModel =  new smapi.community.AccessibilityNeedModel({
                AccessibilityNeedTypeID: self.AccessibilityNeedTypeID(),
                DisabilityStatusID: self.DisabilityStatusID(),
                Description: self.Description(),
                EffectsAssessments: 1,
                ID: self.ID(),
                GID: self.GID()
            });

            if(ukFeatureEnabled){
                var disabledStudentAllowanceInformation = {
                    DisabledStudentAllowanceID: self.DisabledStudentAllowanceID(),
                    DisabledStudentAllowanceName: self.DisabledStudentAllowanceName()
                };

                return {
                    AccessibilityNeedModel: AccessibilityNeedModel,
                    DisabledStudentAllowanceInformation: disabledStudentAllowanceInformation
                };
            } else {
                return AccessibilityNeedModel;
            }
            
        };

        /*** FILTER FUNCTION ***/
        self.DisabilityStatusFilter = function (accessibilityNeedTypeID) {

            var sourceMatrix = self.DisabilityStatusMatrix;

            var resultList = Array();

            for (var i = 0; i < sourceMatrix.length; i++) {

                var currentItem = sourceMatrix[i];

                // Construct the Match Checkers
                var accessibilityNeedTypeMatch = sm.portal.utility.isNullOrEmpty(accessibilityNeedTypeID) ? '' : '|' + accessibilityNeedTypeID + '|';

                // Make the checks
                var isMatch = true;

                // Accessibility Need Type
                if (!sm.portal.utility.isNullOrEmpty(accessibilityNeedTypeMatch) && currentItem.AccessibilityNeedTypeIDs.indexOf(accessibilityNeedTypeMatch) < 0) {
                    isMatch = false;
                }

                // Final check for NO FILTER VALUES.
                if (sm.portal.utility.isNullOrEmpty(accessibilityNeedTypeMatch)) {
                    isMatch = false;
                }

                if (isMatch) {
                    var newItem = new smapi.access.ListItemModel({ Text: currentItem.PrimaryText, Value: currentItem.PrimaryID, ID: currentItem.PrimaryID });
                    resultList.push(newItem);
                }
            }

            return resultList;
        }        
        /*** FILTER FUNCTION ***/



        /*** COMPUTED LIST PROPERTIES ***/

        var retValue = sm.portal.vm.custom.callCustomization(
            "OverrideAccessibilityOptions",
            self
        );

        if (sm.portal.utility.isNullOrEmpty(retValue)) {
            self.AvailableDisabilityStatuses = ko.computed(function () {
                return self.DisabilityStatusFilter(self.AccessibilityNeedTypeID());
            }, this);
        } 


        
        /*** COMPUTED LIST PROPERTIES ***/
        sm.portal.vm.custom.callCustomization('OverrideValidationsForAccessibility', self)
        /*** VALIDATION METHODS ***/
        self.AccessibilityNeedTypeID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        self.DisabilityStatusID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            }
        });
        self.Description.extend({
            maxLength: {
                params: 255,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_0CharactersOrLess_Key), '100')
            }
        });

        self.DisabledStudentAllowanceID.extend({
            min: {
                params: -9223372036854775808,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            max: {
                params: 9223372036854775807,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid();
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    };

    function DisabilityStatusListItemViewModel(options) {

        var defaults = {
            PrimaryID: 0,
            PrimaryText: '',
            AccessibilityNeedTypeIDs: ''
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.PrimaryID = ko.observable(settings.PrimaryID);
        this.PrimaryText = ko.observable(settings.PrimaryText);
        this.AccessibilityNeedTypeIDs = ko.observable(settings.AccessibilityNeedTypeIDs);

        return self;
    }

    jQuery.extend(true, sm.portal.vm, {
        AccessibilityNeedViewModel: AccessibilityNeedViewModel,
        AccessibilityNeedDataItem: AccessibilityNeedDataItem,
        DisabilityStatusListItemViewModel: DisabilityStatusListItemViewModel
    });

})(jQuery);